import { useAppSelector } from '../../../../configuration/setup/store';
import { isFleetAdmin } from './redux/permissions.redux';

export const useIsFleetUser = () => !useAppSelector(isFleetAdmin);
